export default "__VITE_ASSET__CMbflQ_I__"